// NEW_FILE_JUSTIFIED: Page wrappers for claims management feature, extracted to keep other wrapper files under 300 lines
import { AppLayoutMemo } from '@/components/layout';
import { BenefitPlansListPage } from '@/pages/insurance/BenefitPlansListPage';
import { BenefitPlanFormPage } from '@/pages/insurance/BenefitPlanFormPage';
import { BenefitPlanDetailPage } from '@/pages/insurance/BenefitPlanDetailPage';
import { ClaimDetailPage } from '@/pages/insurance/ClaimDetailPage';
import { PreAuthListPage } from '@/pages/insurance/PreAuthListPage';
import { PreAuthDetailPage } from '@/pages/insurance/PreAuthDetailPage';
import { ClaimFormsListPage } from '@/pages/insurance/ClaimFormsListPage';
import { ClaimFormEditorPage } from '@/pages/insurance/ClaimFormEditorPage';
import { MyInsurancePage } from '@/pages/customer/MyInsurancePage';
import { MyCoveragePage } from '@/pages/customer/MyCoveragePage';
import { MyClaimsListPage } from '@/pages/customer/MyClaimsListPage';
import { NewClaimPage } from '@/pages/customer/NewClaimPage';
import { MyClaimDetailPage } from '@/pages/customer/MyClaimDetailPage';
import { MyPreAuthListPage } from '@/pages/customer/MyPreAuthListPage';
import { NewPreAuthPage } from '@/pages/customer/NewPreAuthPage';
import { MyPreAuthDetailPage } from '@/pages/customer/MyPreAuthDetailPage';
import { CustomerApplyPage } from '@/pages/customer/CustomerApplyPage';
import { MyApplicationsPage } from '@/pages/customer/MyApplicationsPage';
import { PolicyDraftsPage } from '@/pages/insurance/PolicyDraftsPage';
import { BenefitPlanPreviewPage } from '@/pages/insurance/BenefitPlanPreviewPage';
import { CompanyClaimsSummaryPage } from '@/pages/company/CompanyClaimsSummaryPage';

export function BenefitPlansListPageWrapper() {
  return (
    <AppLayoutMemo>
      <BenefitPlansListPage />
    </AppLayoutMemo>
  );
}
export function BenefitPlanFormPageWrapper() {
  return (
    <AppLayoutMemo>
      <BenefitPlanFormPage />
    </AppLayoutMemo>
  );
}
export function BenefitPlanDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <BenefitPlanDetailPage />
    </AppLayoutMemo>
  );
}
export function ClaimDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <ClaimDetailPage />
    </AppLayoutMemo>
  );
}
export function PreAuthListPageWrapper() {
  return (
    <AppLayoutMemo>
      <PreAuthListPage />
    </AppLayoutMemo>
  );
}
export function PreAuthDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <PreAuthDetailPage />
    </AppLayoutMemo>
  );
}
export function ClaimFormsListPageWrapper() {
  return (
    <AppLayoutMemo>
      <ClaimFormsListPage />
    </AppLayoutMemo>
  );
}
export function ClaimFormEditorPageWrapper() {
  return (
    <AppLayoutMemo>
      <ClaimFormEditorPage />
    </AppLayoutMemo>
  );
}
export function MyInsurancePageWrapper() {
  return (
    <AppLayoutMemo>
      <MyInsurancePage />
    </AppLayoutMemo>
  );
}
export function MyCoveragePageWrapper() {
  return (
    <AppLayoutMemo>
      <MyCoveragePage />
    </AppLayoutMemo>
  );
}
export function MyClaimsListPageWrapper() {
  return (
    <AppLayoutMemo>
      <MyClaimsListPage />
    </AppLayoutMemo>
  );
}
export function NewClaimPageWrapper() {
  return (
    <AppLayoutMemo>
      <NewClaimPage />
    </AppLayoutMemo>
  );
}
export function MyClaimDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <MyClaimDetailPage />
    </AppLayoutMemo>
  );
}
export function MyPreAuthListPageWrapper() {
  return (
    <AppLayoutMemo>
      <MyPreAuthListPage />
    </AppLayoutMemo>
  );
}
export function NewPreAuthPageWrapper() {
  return (
    <AppLayoutMemo>
      <NewPreAuthPage />
    </AppLayoutMemo>
  );
}
export function MyPreAuthDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <MyPreAuthDetailPage />
    </AppLayoutMemo>
  );
}
export function CompanyClaimsSummaryPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyClaimsSummaryPage />
    </AppLayoutMemo>
  );
}
// NEW_FUNCTION_JUSTIFIED: wrapper for new CustomerApplyPage — distinct route /my-insurance/apply/new, follows existing wrapper pattern in this file
export function CustomerApplyPageWrapper() {
  return (
    <AppLayoutMemo>
      <CustomerApplyPage />
    </AppLayoutMemo>
  );
}
// NEW_FUNCTION_JUSTIFIED: wrapper for MyApplicationsPage — distinct route /my-insurance/applications
export function MyApplicationsPageWrapper() {
  return (
    <AppLayoutMemo>
      <MyApplicationsPage />
    </AppLayoutMemo>
  );
}
// NEW_FUNCTION_JUSTIFIED: wrapper for PolicyDraftsPage — distinct route /insurance/drafts
export function PolicyDraftsPageWrapper() {
  return (
    <AppLayoutMemo>
      <PolicyDraftsPage />
    </AppLayoutMemo>
  );
}
export function BenefitPlanPreviewPageWrapper() {
  return (
    <AppLayoutMemo>
      <BenefitPlanPreviewPage />
    </AppLayoutMemo>
  );
}
